(function ($) {
 

    $(window).on("load", function(){
          var $body = $('body'),
        $doc = $(document),
        $html = $('html'),
        $win = $(window);
      //adding custom attr on the book now button 
      setTimeout(function(){
        jQuery(".otGroupButton #omega-cta-button-42322").attr("data-book-a-demo", "");
      }, 700)
      jQuery("#custom-map-template--22935329931581__google_map_HmnAcb button").attr("data-book-a-demo", "");
      $doc.on('chsnge', '.global-checkbox--input', (event) => {
                  var targetId = event.target.getAttribute('data-target');
  
                  if(event.target.checked){
                      $(targetId).attr('disabled', false);
                  } else{
                      $(targetId).attr('disabled', true);
                  }
              });
  
          $doc.on('click', '[data-book-a-demo]', (event) => {
              event.preventDefault();
              event.stopPropagation();
              $body.addClass('book-a-demo-show');
          });

          $doc.on('click', '[data-close-book-a-demo-popup ]', (event) => {
              event.preventDefault();
              event.stopPropagation();
              $body.removeClass('book-a-demo-show');
          });

          $doc.on('click', (event) => {
              setTimeout(() => {
                  if ($body.hasClass('cart-sidebar-show')) {
                      if (($(event.target).closest('[data-book-a-demo-popup]').length === 0)){
                          $body.removeClass('book-a-demo-show');
                      }
                  }
                  if ($body.hasClass('book-a-demo-show')) {
                      if ($(event.target).closest('[data-book-a-demo-popup]').length === 0){
                          $body.removeClass('book-a-demo-show');
                      }
                  }
              }, 10);
          });
    })
    

  
})(jQuery);
